import s from "styled-components";
import { Button } from "_c/button";

export const LinkButton = s(Button)`
  padding: 7px 14px;  
`;
export const PinIc = s.span`
  min-width: 15px;
`;
export const Popup = s.div`
  font-family: ${({ theme }) => theme.font.main};
  position: relative;
  width: 300px;
  padding: 12px;
  padding-bottom: 20px;
  border-radius: 9px;
  color: #6e6371;
`;
export const Content = s.div`
  display: flex;
  flex-direction: column;
  margin-inline-start: 15px;
`;
export const RateWrap = s.div`
  display: flex;
`;
export const Rating = s.span`
  margin-inline-end: 5px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(-30deg, #c89812 0%, #f8c40c 30%, #c89812 83%, #ffe68f 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`;
export const RatingCount = s.span`
  color: white;
  font-size: 14px;
  position: relative;
  bottom: -1px;
`;
export const AddressWrap = s.div`
  display: flex;
  align-items: center;
  margin-top: 10px;  
  font-weight: 400;
  margin-bottom: 15px;
  address {
    font-style: normal;
    margin-inline-start: 7px;
    color: white;
    max-width: 250px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
  }
`;
export const CloseButton = s.button`
  padding: 0;
  width: 25px;
  height: 25px;
  position: absolute;
  ${({ theme }) => `${theme.rtl ? "left" : "right"}: 10px;`};
  top: 10px;
`;
export const InnerWrap = s.div`
  display: flex;
`;
export const Name = s.span`
  color: white;
  font-weight: 500;
  font-size: 16px;
`;

export const PremiumCircle = s.div`
  width: 40px;
  height: 40px;
  display: flex;
  background-color: var(--color-primary);
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  img {
    width: 30px;
  }
`;
